import useAppStateStore from "../../../shared/store/AppStateStore";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const NewQuoteMapper = {
  set(data) {
    const STATE = useAppStateStore.getState();
    const setLookupAddress = STATE.setLookupAddress;

    // Occupation & Driver fields
    updateQuoteFields({
      "risk.drivers.0.occupations.0.occupationId": "D34",
      "risk.drivers.0.occupations.0.employmentStatusId": "S",
      "risk.drivers.0.occupations.0.employersBusinessId": "703",
      "risk.drivers.0.occupations.0.partTime": false,
      "risk.drivers.0.datePassedTest": data.risk.drivers[0].datePassedTest,
      "risk.drivers.0.uberDriverId": data.risk.drivers[0].uberDriverId,
      "risk.drivers.0.titleId": data.risk.drivers[0].titleId,
      "risk.drivers.0.forename": data.risk.drivers[0].forename,
      "risk.drivers.0.surname": data.risk.drivers[0].surname,
      "risk.drivers.0.emailAddress": data.risk.drivers[0].emailAddress,
      "risk.drivers.0.licenceNumber": data.risk.drivers[0].licenceNumber,
      "risk.drivers.0.telephone": data.risk.drivers[0].telephone,
      "risk.drivers.0.uberDriverRatingId":
        data.risk.drivers[0].uberDriverRatingId,
      "risk.drivers.0.dateOfBirth": data.risk.drivers[0].dateOfBirth,
      "risk.drivers.0.maritalStatusId": null,
      "risk.drivers.0.insuranceCancelled": null,
      "risk.vehicles.0.purchaseDate": null,
      "risk.vehicles.0.interiorCamera": null,
      "risk.vehicles.0.ncdDetails.years": null,
      "risk.vehicles.0.havePreviousRegistration": null,
      "risk.riskObjectId": data.risk.riskObjectId,
    });

    // Vehicle fields
    if (data?.risk?.vehicles?.[0]?.preVehicleSearchSuccess === true) {
      updateQuoteFields("risk.vehicles.0", data.risk.vehicles[0]);
      STATE.setLookupData(true);
    } else if (data?.risk?.vehicles?.[0]?.preVehicleSearchSuccess === false) {
      updateQuoteFields(
        "risk.vehicles.0.licensingPlateNumber",
        data.risk.vehicles[0].licensingPlateNumber
      );
      STATE.setLookupData(false);
    } else {
      updateQuoteFields({
        "risk.vehicles.0.licensingPlateNumber": null,
      });
      STATE.setLookupData(false);
    }

    // Address fields
    if (data.isValidAddressOnNewQuote) {
      updateQuoteFields({
        "risk.drivers.0.address": data.risk.drivers[0].address,
        "risk.drivers.0.address.postcode":
          data.risk.drivers[0].address.postcode,
        "risk.drivers.0.address.houseNo": data.risk.drivers[0].address.houseNo,
      });
      setLookupAddress(data.risk.drivers[0].address);
    }

    // State flags
    STATE.setIsValidVehicleOnNewQuote(data.isValidVehicleOnNewQuote);
    STATE.setIsValidAddressOnNewQuote(data.isValidAddressOnNewQuote);
  },
};

export default NewQuoteMapper;
